export const data1 = `| |Focus area|Metric tracked|Comp 1|Comp 2|Comp 3|Comp 4|
|1|Portfolio segmentation|Retail unsecured (% of NPL)|68|82|98|118|
| | |Mortgage (% of NPL)|62|56|50|45|
|2|Contactability|Reachable customers (%)|58|70|84|100|
| | |Valid phone/email on file (%)|52|47|42|38|
|3|Process efficiency|Cases handled digitally (%)|46|55|66|79|
| | |Avg. handling time (minutes)|38|34|31|28|`;

export const data2 = `|Kick off change|1|2|3|4|5|
| |Improve reachability|Digitize collections|Optimize vendor performance|Segment portfolio|Reduce handling time|
| |Clean and enrich contact data, increase valid phone/email coverage|Shift more cases to digital, automate workflows and nudges|Reallocate cases to top vendors, enforce recovery targets|Separate unsecured vs mortgage, tailor strategies by segment|Streamline processes, reduce manual steps and delays|`;
